module.exports = __webpack_public_path__ + "img/icon_selected.552c2647.svg";